var paywall = require("./lib/paywall");
setTimeout(() => paywall(13339497), 5000);

require("component-responsive-frame/child");